<form #checkout="ngForm" (ngSubmit)="onSubmit(checkout)" ngClass.gt-sm="checkout" ngClass.lt-md="checkout-mobile">
  <div class="form-row">
    <label for="card-info">Card Info</label>
    <div id="card-info" #cardInfo></div>
    <div class='StripeElement' style='height:18px;color:silver'>
      <span style='float:left;margin-right:10px'>
        <i *ngIf='!lookingForDiscount' class='fa fa-money'> </i>
        <i *ngIf='lookingForDiscount' class='fa fa-spinner fa-spin'> </i>
      </span>
      <span style='float:left'>
        <input [(ngModel)]="promoCode" placeholder="Promo Code" [ngModelOptions]="{standalone: true}"
          (keyup)="checkDiscount()" (change)='checkDiscount()'>
      </span>
    </div>
    <div *ngIf='discount' class='discount'>
      Discount: {{discount | currency}}
    </div>
    <div id="card-errors" role="alert" *ngIf="error">{{ error }}</div>
  </div>
  <button type="submit" [disabled]='paymentComplete'>Upgrade {{getDisplayPrice() | currency}} <i *ngIf='processing'
      class='fa fa-spinner fa-spin'></i></button>
</form>
<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
  <div style='text-align:center' class='s18-font'
    matTooltip="At Golf GamesKeeper, we're serious about protecting your personal information. To ensure your account details are safe, we use Secure Sockets Layer (SSL), an industry standard for encrypting private data over the Internet.">
    <i class='fa fa-lock' style='color:goldenrod;'> </i> Secure
  </div>
  <div style='text-align:center' class='s18-font'
  matTooltip="By subscribing you authorize us to charge you the subscription cost (as described above) automatically, charged
  yearly/monthly to the payment method provided.
  You could see a payment authorization up to 72 hours before your current subscription or free trial expires. You won't
  be charged until the actual renewal date. To avoid unwanted charges, you need to cancel your subscription before it
  expires. Golf Game Keeper will not issue refund or prorate subscription.">
    <i class="fa fa-exclamation-circle"> </i> Refund Policy 
  </div>
</div>
